import { Heading, type HeadingProps } from '@chakra-ui/react';
import { memo } from 'react';

const ClassTitle = memo(function ClassTitle(props: HeadingProps) {
  return <Heading fontSize={['xs', 'sm', 'md']} noOfLines={3} {...props} />;
});

export default ClassTitle;
